/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import Card from '../../card/index';
import LockedProfileIcon from '../../../assets/locked-profile.svg';

import style from './index-module.css';

const PrivateProfile: Function = (): React$Element<*> => (
  <Card className={style.container}>
    <div className={style.icon}>
      <LockedProfileIcon />
    </div>
    <FormattedMessage id="profile.is-private" defaultMessage="This profile is private." />
  </Card>
);

export default PrivateProfile;



// WEBPACK FOOTER //
// ./src/components/profile/private-events/index.js